export const CREATE_SITE_TABS = {
  NAME: 'name',
  SEGMENT: 'segment',
  INFOS: 'infos',
};

export const CREATE_SITE_AGENT_TABS = {
  NAME_SEGMENT: 'name-segment',
  INFOS: 'infos',
};

export const SEGMENTS = {
  ACCOUNTING: 'Accounting',
  BOOKKEEPING: 'Bookkeeping',
  FINANCIAL_CONSULTING: 'Financial Consulting',
  ACUPUNCTURE: 'Acupuncture',
  CHIROPRACTOR: 'Chiropractor',
  DENTIST: 'Dentist',
  DOCTOR: 'Doctor',
  MASSAGE_THERAPY: 'Massage Therapy',
  PHYSIOTHERAPY: 'Physiotherapy',
  PSYCHOLOGY: 'Psychology',
  WELLNESS: 'Wellness',
  YOGA_INSTRUCTION: 'Yoga Instruction',
  BARBER_SHOP: 'Barber Shop',
  BEAUTY: 'Beauty',
  HAIR_STYLIST: 'Hair Stylist',
  MAKEUP_ARTIST: 'Makeup Artist',
  BAKERY: 'Bakery',
  CAFE: 'Cafe',
  CATERING: 'Catering',
  CHEF: 'Chef',
  COFFEE_SHOP: 'Coffee Shop',
  FAST_FOOD: 'Fast Food',
  PIZZA_RESTAURANT: 'Pizza Restaurant',
  RESTAURANT: 'Restaurant',
  BUSINESS_CONSULTING: 'Business Consulting',
  CAREER_COACHING: 'Career Coaching',
  COACHING: 'Coaching',
  CONSULTING: 'Consulting',
  COUNSELLING: 'Counselling',
  EDUCATION: 'Education',
  IT_CONSULTING: 'IT Consulting',
  LAW_FIRM: 'Law Firm',
  PROJECT_MANAGEMENT: 'Project Management',
  PUBLIC_RELATIONS: 'Public Relations',
  RESUME_WRITING: 'Resume Writing',
  SOCIAL_MEDIA_MARKETING: 'Social Media Marketing',
  TRANSLATION: 'Translation',
  AUDIO_EDITING: 'Audio Editing',
  AUDIO_PRODUCTION: 'Audio Production',
  CONTENT_WRITING: 'Content Writing',
  COPYWRITING: 'Copywriting',
  DESIGN: 'Design',
  DEVELOPMENT_AND_DESIGN: 'Development and Design',
  DIGITAL_MARKETING: 'Digital Marketing',
  GRAPHIC_DESIGN: 'Graphic Design',
  ILLUSTRATING: 'Illustrating',
  MARKETING: 'Marketing',
  PHOTOGRAPHY: 'Photography',
  VIDEO_EDITING: 'Video Editing',
  VIDEO_PRODUCTION: 'Video Production',
  WRITING: 'Writing',
  PROPERTY_MANAGEMENT: 'Property Management',
  REAL_ESTATE: 'Real Estate',
  REAL_ESTATE_AGENCY: 'Real Estate Agency',
  COMPUTER_REPAIR: 'Computer Repair',
  MOBILE_REPAIR: 'Mobile Repair',
  SOFTWARE_DEVELOPMENT: 'Software Development',
  UI_UX_DESIGN: 'UI/UX Design',
  WEB_DESIGN: 'Web Design',
  WEB_DEVELOPMENT: 'Web Development',
  CAR_DETAILING: 'Car Detailing',
  CAR_RENTALS: 'Car Rentals',
  ELECTRIC_VEHICLES: 'Electric Vehicles',
  EV_RENTALS: 'EV Rentals',
  MECHANIC: 'Mechanic',
  TAXI: 'Taxi',
  TRUCKING: 'Trucking',
  CLEANING: 'Cleaning',
  CARPET_CLEANING: 'Carpet Cleaning',
  ELECTRICIAN: 'Electrician',
  GARDENING: 'Gardening',
  HANDYMAN: 'Handyman',
  HOUSE_CLEANING: 'House Cleaning',
  LANDSCAPING: 'Landscaping',
  LAWN_CARE: 'Lawn Care',
  PAINTING: 'Painting',
  PLUMBING: 'Plumbing',
  POOL_CLEANING: 'Pool Cleaning',
  PRESSURE_WASHING: 'Pressure Washing',
  DOG_TRAINING: 'Dog Training',
  DOG_WALKING: 'Dog Walking',
  PET_SITTING: 'Pet Sitting',
  FITNESS: 'Fitness',
  PERSONAL_TRAINING: 'Personal Training',
  SPORTS_INSTRUCTION: 'Sports Instruction',
  DJ: 'DJ',
  EVENT_PLANNING: 'Event Planning',
  ONLINE_ENTERTAINMENT: 'Online Entertainment',
  ONLINE_STORE: 'Online Store',
  RETAIL_STORE: 'Retail Store',
  SOLAR_INSTALLATION: 'Solar Installation',
  BIKE_MECHANIC: 'Bike Mechanic',
  BOAT_DETAILING: 'Boat Detailing',
  CONSTRUCTION: 'Construction',
  FOOD_DELIVERY: 'Food Delivery',
  INFLUENCE_MARKETING: 'Influence Marketing',
  INSURANCE_BROKER: 'Insurance Broker',
  INTERIOR_DESIGN: 'Interior Design',
  LOCKSMITH: 'Locksmith',
  MAKE_UP_ARTIST: 'Make-up Artist',
  MUSIC_INSTRUCTION: 'Music Instruction',
  ONLINE_LEARNING: 'Online Learning',
  PEST_CONTROL: 'Pest Control',
  SECURITY: 'Security',
  TRAVEL_AGENCY: 'Travel Agency',
  YOUTUBER: 'YouTuber',
};

export const BRANDS_LIST = [
  'br',
  'mx',
  'cl',
  'co',
  'ar',
  'pe',
  'ec',
  'do',
  'uy',
  'cr',
  'bo',
  'py',
  'sv',
  'pa',
];
